import React from "react";
import { Link } from "react-router-dom";
import { Breakpoint } from "../../hooks/useBreakpoint";
import { Button } from "react-bootstrap";
import { updateStandings } from "../../lib/api";
import { ILocalStorageUserData } from "../../types/users";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { alertActions } from "../../features/alert/alertSlice";

const IndividualLeagueSidebarButtons = ({
    breakpoint,
    toggleNavbar,
    routePrefix,
    league,
    setModalLeagueId,
    setModalAction,
    setShowModal,
}: {
    breakpoint: Breakpoint;
    toggleNavbar: () => void;
    routePrefix: string;
    league: number;
    setModalLeagueId: React.Dispatch<React.SetStateAction<number | undefined>>;
    setModalAction: React.Dispatch<React.SetStateAction<"assign" | "reset">>;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const { user } = useAppSelector(state => state.auth) as {
        user: ILocalStorageUserData["user"];
    };

    const dispatch = useAppDispatch();

    return (
        <>
            <Link
                to={`${routePrefix}/league/${league}/schedule`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                League Schedule
            </Link>
            <Link
                to={`${routePrefix}/league/${league}/playoffSchedule`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                Playoff Schedule
            </Link>
            <Link
                to={`${routePrefix}/league/${league}/standings`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                League Standings
            </Link>
            <Link
                to={`${routePrefix}/league/${league}/playoffs`}
                className="btn btn-primary"
                onClick={toggleNavbar}
            >
                League Playoff Bracket
            </Link>
            <Button
                className="btn btn-primary"
                onClick={() => {
                    updateStandings(league, user.id);
                    dispatch(
                        alertActions.success({
                            title: "Standings update in progress...",
                            text: "Please wait a few seconds for it to complete",
                            dismissible: true,
                            persist: false,
                        }),
                    );
                }}
            >
                Update Standings
            </Button>
            <Button
                className="btn btn-primary"
                onClick={() => {
                    toggleNavbar();
                    setModalAction("assign");
                    setModalLeagueId(league);
                    setShowModal(true);
                }}
            >
                Assign Playoff Seeds
            </Button>
            <Button
                className="btn btn-primary"
                onClick={() => {
                    toggleNavbar();
                    setModalAction("reset");
                    setModalLeagueId(league);
                    setShowModal(true);
                }}
            >
                Reset Playoff Seeds
            </Button>
        </>
    );
};

export default IndividualLeagueSidebarButtons;
